module.exports = __webpack_public_path__ + "img/email.aa10ca6b.png";